import { coreLayoutContainer, coreLayoutSection } from '@/constants/measured-scope'
import { useFeatureToggle } from '@/context/featureToggles'
import { SponsorInfoContent } from '@/shared/api-generated-types'
import React from 'react'
import * as styles from './style'
export interface Props {
  sponsorInfoContent: SponsorInfoContent
  className?: string
}

const SponsorInfoBlock = ({ sponsorInfoContent, className }: Props): JSX.Element => {
  const enableSponsorship = useFeatureToggle('exp_sponsorships')

  return enableSponsorship ? (
    <div className={className ? className : coreLayoutSection}>
      <div className={`${styles.root} ${className ? className : coreLayoutContainer}`}>
        <div className={styles.logoContainer}>
          <img src={sponsorInfoContent?.logoUrl} className={styles.image} />
          <div className={styles.sponsorNameContainer}>
            <div className={styles.sponsorBy}>Sponsored By</div>
            <div className={styles.sponsorName}>{sponsorInfoContent?.name}</div>
          </div>
        </div>
        <div className={styles.info}>{sponsorInfoContent?.description}</div>
      </div>
    </div>
  ) : (
    <></>
  )
}
export default SponsorInfoBlock
